import { useMemo } from "react";
import { Link } from "react-router-dom";
import { cssX, FCX, markMatch } from "@datassential/platform-ui-lib";
import classNames from "classnames";
import { iSearchResultsItem, ItemTypeEnum, SearchResults } from "@models/SearchResults";
import { escapeRegExp } from "@core/helpers";

interface SearchResultItemTitleProps {
    item: iSearchResultsItem;
    index: number;
    sectionId: ItemTypeEnum;
    search: string;
}

export const SearchResultItemTitle: FCX<SearchResultItemTitleProps> = ({
    item,
    index,
    sectionId,
    search,
}) => {
    const content = useMemo(() => {
        return markMatch(item.name, escapeRegExp(search)); 
    }, [item.name, search]);

    if (sectionId !== ItemTypeEnum.FoodProfile ) {
        return (
            <Link
                className={classNames(cssX('Dropdown__item'), "ToolSearch__itemTitle")}
                to={SearchResults.getItemLink(item, sectionId)}
            >
                <span
                    className="ToolSearch__itemTitleName"
                    data-testid="textHeaderSearchResultTitle"
                    dangerouslySetInnerHTML={{
                        __html: content,
                    }}
                />
            </Link>
        )
    }

    return (
        <div className={classNames(cssX('Dropdown__item'), "ToolSearch__itemTitle")}>
            <span
                className="ToolSearch__itemTitleName"
                data-testid="textHeaderSearchResultTitle"
                dangerouslySetInnerHTML={{
                    __html: content,
                }}
            />
            <span data-testid="textHeaderSearchResultSubTitle">
                {SearchResults.getItemSubTitle(item, index, sectionId)}
            </span>
        </div>
    )
};
